import { useParams } from 'react-router-dom';

import { PhotoshootResultScreen } from '@/features/generation/PhotoshootResultScreen';

export function PhotoshootPage() {
  const { photoshootId } = useParams<{ photoshootId: string }>();

  if (!photoshootId) {
    return <p className="px-6 py-8 text-danger">Фотосессия не указана.</p>;
  }

  return (
    <main className="flex flex-col">
      <h1 className="px-6 pt-8 font-display text-h1 text-text">Фотосессия</h1>
      <PhotoshootResultScreen photoshootId={photoshootId} />
    </main>
  );
}
